/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Keyboard, Pagination } from 'swiper/modules';
/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container) {
	const parameters = {
		slidesPerView: 1,
		spaceBetween: 24,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			992: {
				slidesPerView: 3,
			}
		},
		loop: false,
		autoHeight: true,
		calculateHeight: true,
		autoplay: false,
		initialSlide: 0,
		keyboard: true,
		modules: [Autoplay, Keyboard, Pagination],
		pagination: {
			el: '.rlt-editors-hero-pagination .swiper-pagination',
			clickable: true,
		},
		simulateTouch: true,
	};

	return new Swiper(container, parameters);
}
